var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showDefaultRegistrationPage)?_c('registration-page'):_c('dynamic-event-page')}
var staticRenderFns = []

export { render, staticRenderFns }